const useZipCodeBase = process.env.NEXT_PUBLIC_USE_ZIPCODEBASE
  ? process.env.NEXT_PUBLIC_USE_ZIPCODEBASE === 'true'
  : false;

const getSpredlyToken = (creditCard, openPay = true) => {
  return new Promise(async (resolve, reject) => {
    window.Spreedly.on('errors', function (errors) {
      for (var i = 0; i < errors.length; i++) {
        var error = errors[i];
        if (error.message) {
          resolve({ error: error.message });
          break;
        } else {
          continue;
        }
      }
    });

    window.Spreedly.on('paymentMethod', function (token, pmData) {
      return resolve(token);
    });

    if (!openPay) {
      const { validity, name, zipCode } = creditCard;
      let requiredFields = {};
      const expiration_year = validity.substring(2, 4);
      const expiration_month = validity.substring(0, 2);
      requiredFields['full_name'] = name;
      requiredFields['month'] = expiration_month;
      requiredFields['year'] = '20' + expiration_year;
      requiredFields['zip'] = zipCode;
      window.Spreedly.tokenizeCreditCard(requiredFields);
    } else {
      let state = '';
      let city = '';
      let countryCode = '';

      const { validity, name, zipCode, country } = creditCard;
      if (useZipCodeBase) {
        const contryCode = await getCountryFromLocation(zipCode, country?.code);
        if (contryCode.error) return resolve({ error: contryCode.error });
        state = contryCode.state ? contryCode.state : 'null';
        city = contryCode.city ? contryCode.city : 'null';
        countryCode = contryCode.country_code
          ? contryCode.country_code
          : country?.code;
      } else {
        state = creditCard.state ? creditCard.state : 'null';
        city = creditCard.city ? creditCard.city : 'null';
        countryCode = country?.code;
      }

      let requiredFields = {};
      const expiration_year = validity.substring(2, 4);
      const expiration_month = validity.substring(0, 2);
      requiredFields['full_name'] = name;
      requiredFields['month'] = expiration_month;
      requiredFields['year'] = '20' + expiration_year;
      requiredFields['address1'] = 'null';
      requiredFields['city'] = city;
      requiredFields['state'] = state;
      requiredFields['zip'] = zipCode;
      requiredFields['country'] = countryCode;
      window.Spreedly.tokenizeCreditCard(requiredFields);
    }
  });
};

const getCountryFromLocation = async (zipCode, country) => {
  return new Promise(async (resolve, reject) => {
    try {
      const location = await getLocationLatLng(zipCode, country || 'MX');
      if (!location.country_code) {
        const country = await getGetCountryFromApi(location);
        return resolve(country);
      }

      return resolve(location);
    } catch (error) {
      return resolve(error);
    }
  });
};

const getLocationLatLng = async (zipCode, country) => {
  return new Promise(async (resolve, reject) => {
    try {
      const dataCode = await getCountryFromZipCode(zipCode, country);
      resolve(dataCode);
    } catch (err) {
      return reject({ error: err });
    }
  });
};

// const getLocationLatLng = async (zipCode) => {
//   return new Promise((resolve, reject) => {
//     const successCallback = (position) => {
//       console.log(position);
//       resolve(position);
//     };

//     const errorCallback = async (errorCallback) => {
//       try {
//         const dataCode = await getCountryFromZipCode(zipCode);
//         resolve(dataCode);
//       } catch (err) {
//         return reject({error: err});
//       }
//       return reject({error: 'No pudimos obtener acceso a tu ubicación.'});
//     };

//     navigator.geolocation.getCurrentPosition(successCallback, errorCallback);
//    })
// }

const getCountryFromZipCode = async (zipCode, country) => {
  return new Promise(async (resolve, reject) => {
    const response = await fetch(
      `https://app.zipcodebase.com/api/v1/search?apikey=${process.env.NEXT_PUBLIC_ZIPCODE_API_KEY}&codes=${zipCode}&country=${country}`,
    );
    const codes = await response.json();
    const { results } = codes;
    if (!results[zipCode]) {
      return reject('Código postal invalido');
    }
    const dataCode = results[zipCode][0];
    return resolve(dataCode);
  });
};

const getGetCountryFromApi = async (location) => {
  return new Promise(async (resolve, reject) => {
    const response = await fetch(
      `https://maps.googleapis.com/maps/api/geocode/json?latlng=${location.coords.latitude},${location.coords.longitude}&key=${process.env.NEXT_PUBLIC_GOOGLE_MAPS_KEY}`,
    );
    const data = await response.json();
    if (!data)
      return reject({
        error: 'No pudimos obtener acceso a la información tu ubicación.',
      });

    for (const iterator of data.results) {
      for (const itemIterator of iterator.address_components) {
        if (itemIterator.types.includes('country')) {
          return resolve(itemIterator.short_name);
        }
      }
    }

    return reject({ error: 'Esta ubicación no es valida.' });
  });
};

export default getSpredlyToken;
